export function DateFormaterMonth(GettedDate) {
    if (!GettedDate) {
        return ``;
    }

    const date = new Date(GettedDate);
    if (isNaN(date.getTime())) {
        return ``;
    }

    // Get the day, month (zero-padded), and year
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
}